import React, { FC } from 'react';
import { getShortUserName, useStore } from '@utils';
import { Cross } from '../svgs';
import { CalendarPopup } from './CalendarPopup';
import { MembersStore } from '../../store';
import { Avatar } from '@mui/material';
import { observer } from 'mobx-react-lite';

interface HeaderMobileLeftPartProps {
  selectEmployeeId: number;
  resetEmployee: () => void;
}
export const HeaderMobileLeftPart: FC<HeaderMobileLeftPartProps> = observer(({ selectEmployeeId, resetEmployee }) => {
  const membersStore = useStore(MembersStore);
  const user = membersStore.getMemberById(selectEmployeeId);
  
  return (
    <>
      {user === undefined
        ? <CalendarPopup />
        : (
          <div className="selected-header-user">
            <div className="left-block">
              <Avatar
                src={user.img}
                className='avatar'
              />
              
              <div className="info">
                <p className="name">{getShortUserName(user.fullName)}</p>
                <p className="position">{user.position}</p>
              </div>
            </div>
            <Cross onClick={resetEmployee}/>
          </div>
        )
      }
    </>
  );
});
